'use client';

import { c as _c } from "react/compiler-runtime";
import { QuickFilters, type QuickFiltersLayout, type QuickFiltersSelectionMode, type QuickFilterValue } from '@/components/filters/QuickFilters';
import { useOpportunitiesQuickFilters } from '@/lib/hooks/useOpportunitiesQuickFilters';
interface OpportunitiesQuickFiltersProps {
  /** Current opportunities filter selection (`Record<facetKey, optionIds[]>`). */
  value: QuickFilterValue;
  /** Called with the next selection when a preset is toggled. */
  onChange: (value: QuickFilterValue) => void;
  /** Optional leading label shown before the pills. Defaults to "Quick picks". */
  label?: string;
  /** Display style. Defaults to `auto` (dropdown on mobile, pills otherwise). */
  layout?: QuickFiltersLayout;
  /** Selection behaviour. Defaults to `quick` (one-shot shortcuts, no state). */
  selectionMode?: QuickFiltersSelectionMode;
  className?: string;
}

/**
 * Opportunities quick-filter pills. Domain wrapper around the generic
 * {@link QuickFilters}: it pulls the opportunities presets via
 * {@link useOpportunitiesQuickFilters} (metadata-driven, with defaults). The
 * browser filter value is already a `Record<string, string[]>`, so no bridging
 * is needed.
 *
 * Renders nothing until presets are available (the hook is non-optimistic, so
 * the pills appear once loaded rather than flashing defaults).
 */
export function OpportunitiesQuickFilters(t0) {
  const $ = _c(9);
  const {
    value,
    onChange,
    label: t1,
    layout,
    selectionMode,
    className
  } = t0;
  const label = t1 === undefined ? "Quick filter" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      optimistic: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    presets
  } = useOpportunitiesQuickFilters(t2);
  if (presets.length === 0) {
    return null;
  }
  let t3;
  if ($[1] !== className || $[2] !== label || $[3] !== layout || $[4] !== onChange || $[5] !== presets || $[6] !== selectionMode || $[7] !== value) {
    t3 = <QuickFilters className={className} label={label} layout={layout} selectionMode={selectionMode} presets={presets} value={value} onChange={onChange} />;
    $[1] = className;
    $[2] = label;
    $[3] = layout;
    $[4] = onChange;
    $[5] = presets;
    $[6] = selectionMode;
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}